import { CursorDef, HighlightDef, find_highlight_positions } from './find_element_positions';

export function find_separated_highlight_positions(
  input: { lyrics: string, gabc: string, nabc?: string },
  cursor: CursorDef,
): {
  'lyrics': HighlightDef,
  'gabc': HighlightDef,
  'nabc': HighlightDef,
  syllableIndex?: number,
} {
  try {
    return find_highlight_positions(cursor, input.lyrics, input.gabc, input.nabc);
  } catch {
    return {
      'lyrics': { index: 0, length: 0 },
      'gabc': { index: 0, length: 0 },
      'nabc': { index: 0, length: 0 },
      syllableIndex: -1,
    };
  }
}

export function split_metadata(input: string): [string | undefined, string] {
  let metadata = undefined, gnabc = '';
  const result = input.split('%%');

  for (let chunk of result) {
    chunk = chunk.trim();
    const lines = chunk.split('\n');
    if (lines.length > 0 && lines[0].trim().endsWith(';')) {
      if (!metadata) {
        metadata = '';
      }
      metadata += chunk + '\n';
    } else {
      gnabc += chunk + '\n';
    }
  }

  return [metadata, gnabc];
}

export function find_compounded_highlight_positions(
  input: string,
  cursor: CursorDef,
): {
  highlight: HighlightDef,
  syllableIndex: number,
} {
  try {
    const [metadata, trimmed] = split_metadata(input);
    if (cursor.indexType === 'syllable') {
      const sylStartIndex = find_compounded_syllable_start_index(trimmed, cursor.index);
      const sylEndIndex = trimmed.indexOf(')', sylStartIndex);
      return {
        highlight: {
          index: (metadata?.length ? metadata?.length + 2 : 0) + sylStartIndex,
          length: sylEndIndex - sylStartIndex + 1,
        },
        syllableIndex: cursor.index,
      };
    } else {
      const prev = input.slice(0, cursor.index < 1 ? 0 : cursor.index - 1);
      const sylStartIndex = Math.max(prev.lastIndexOf(' '), prev.lastIndexOf(')'), prev.lastIndexOf('\n'),);
      const sylEndIndex = input.indexOf(')', cursor.index - 1);

      const sylIndex = find_compounded_syllable_index(trimmed, cursor.index - (metadata ? metadata.length + 2 : 0));
      return {
        highlight: {
          index: sylStartIndex + 1,
          length: sylEndIndex === -1 ? 0 : sylEndIndex - sylStartIndex,
        },
        syllableIndex: sylIndex,
      };
    }
  } catch {
    return {
      highlight: {
        index: 0,
        length: 0,
      },
      syllableIndex: -1
    };
  }
}

function find_compounded_syllable_index(gnabc: string, cursorIndex: number): number {
  let sylIndex = 0;
  for (let i = 0; i < gnabc.length; i++) {
    if (cursorIndex === i) {
      return sylIndex;
    }

    const char = gnabc[i - 1];
    if (char === ')') {
      sylIndex++;
    }
  }

  return sylIndex;
}

function find_compounded_syllable_start_index(gnabc: string, syllable_index: number): number {
  let syl_index = 0;

  for (let i = 0; i < gnabc.length; i++) {
    const char = gnabc[i];
    if (char === ')') {
      syl_index++;
      if (syl_index === syllable_index) {
        return i + 1;
      }
    }
  }

  return syl_index;
}
